import { CompositeFilterDescriptor, SortDescriptor, filterBy, orderBy } from '@progress/kendo-data-query';

import { ResultSetModel } from 'models';

import { hasText } from 'core/utils';

export function filterResultSetsForAutoComplete(text: string, resultSets: ResultSetModel[]) {
  if (!hasText(text)) {
    return [];
  }

  const lowerCaseText = text.toLowerCase();

  const filterDescriptor: CompositeFilterDescriptor = {
    logic: 'or',
    filters: [
      {
        field: 'acronym',
        operator: 'contains',
        value: text,
      },
      {
        field: 'description',
        operator: 'contains',
        value: text,
      },
    ],
  };

  const filtered = filterBy(resultSets, filterDescriptor);

  const sorted = filtered.sort((a, b) => {
    const aAcronym = a.acronym?.toLowerCase() ?? '';
    const bAcronym = b.acronym?.toLowerCase() ?? '';
    const aDescription = a.description?.toLowerCase() ?? '';
    const bDescription = b.description?.toLowerCase() ?? '';

    const aAcronymStartsWith = aAcronym.startsWith(lowerCaseText);
    const bAcronymStartsWith = bAcronym.startsWith(lowerCaseText);

    if (aAcronymStartsWith && !bAcronymStartsWith) {
      return -1;
    }
    if (!aAcronymStartsWith && bAcronymStartsWith) {
      return 1;
    }

    const aDescriptionStartsWith = aDescription.startsWith(lowerCaseText);
    const bDescriptionStartsWith = bDescription.startsWith(lowerCaseText);

    if (aDescriptionStartsWith && !bDescriptionStartsWith) {
      return -1;
    }

    if (!aDescriptionStartsWith && bDescriptionStartsWith) {
      return 1;
    }

    if (aAcronym < bAcronym) {
      return -1;
    }
    if (aAcronym > bAcronym) {
      return 1;
    }

    if (aDescription < bDescription) {
      return -1;
    }
    if (aDescription > bDescription) {
      return 1;
    }

    return 0;
  });

  return sorted;
}

export function resultSetTextFn(resultSet: ResultSetModel) {
  const hasAcronym = hasText(resultSet.acronym);
  const hasDescription = hasText(resultSet.description);
  return hasAcronym && hasDescription
    ? `${resultSet.acronym?.trim()} | ${resultSet.description?.trim()}`
    : hasAcronym
      ? resultSet.acronym?.trim()
      : hasDescription
        ? resultSet.description?.trim()
        : '';
}
